








































































































































































import { Vue, Component } from "nuxt-property-decorator";
import GrBottomBackground from "~/components/common/GrBottomBackground.vue";
import GrButton from "~/components/common/GrButton.vue";
import MaxWidthSection from "~/components/common/MaxWidthSection.vue";
import TwoColumnRow from "~/components/common/TwoColumnRow.vue";
import CommonQuestionsTalent from "~/components/startPageNew/CommonQuestionsTalent.vue";
import CompanyCarousel from "~/components/startPageNew/CompanyCarousel.vue";
import GrMoviePlayer from "~/components/startPageNew/GrMoviePlayer.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import HoldingPhoneImage from "~/components/startPageNew/HoldingPhoneImage.vue";

// import gsap from "gsap";

@Component({
  layout: "talentPublicLayout",
  components: {
    GrButton,
    MaxWidthSection,
    GrMoviePlayer,
    TwoColumnRow,
    CompanyCarousel,
    CommonQuestionsTalent,
    GrPublicFooter,
    GrBottomBackground,
    HoldingPhoneImage,
  },
})
export default class TalentStartPage extends Vue {
  mounted() {
    const hash = this.$route.hash;
    if (hash) {
      this.goToPath(this.$route.fullPath);
    }
  }

  async goToPath(path: string) {
    if (this.$route.hash) {
      await this.$router.replace(path.split("#")[0]!);
    }
    this.$router.replace(path);
  }

  head() {
    return {
      title: this.$t("För talanger").toString(),
    };
  }

  get linkToCreateProfile() {
    return this.localePath({
      name: "talentStart-createProfileStart",
    });
  }

  buttonIsClicked() {
    alert("test is clicked");
  }
}
